import React, { useEffect, useRef, useCallback } from 'react';
import * as echarts from 'echarts';
import { EChartOption } from 'echarts';
import { useSize } from 'ahooks';

import echartsTheme from '../echarts-theme';

echarts.registerTheme(echartsTheme.themeName, echartsTheme.theme);

type Prop = {
  option: Record<string, unknown>;
  className?: string;
  style?: Record<string, unknown>;
  registerMap?: (a: EChartOption) => void;
};

type EchartsType = {
  resize(): void;
  dispose(): void;
  clear(): void;
  setOption(option: Record<string, unknown>, notMerge: boolean): void;
};

const Echarts: React.FC<Prop> = ({ className = '', style = {}, option = {}, registerMap }) => {
  const ele = useRef<HTMLDivElement | null>(null);
  const charts = useRef<EchartsType | null>(null);

  const size = useSize(ele.current);

  const onResize = useCallback(() => {
    if (charts.current) {
      charts.current.resize();
    }
  }, []);

  useEffect(() => {
    let chartsCurrent: EchartsType | null = null;
    if (ele.current) {
      chartsCurrent = echarts.init(ele.current, echartsTheme.themeName, {
        renderer: 'svg'
      });
      charts.current = chartsCurrent;
    }
    if (registerMap) {
      registerMap(echarts);
    }
    return () => {
      if (chartsCurrent) {
        chartsCurrent.dispose();
        chartsCurrent = null;
      }
    };
  }, []);

  useEffect(() => {
    onResize();
  }, [size]);

  useEffect(() => {
    if (charts.current && option) {
      charts.current.clear();
      charts.current.setOption(option, false);
    }
  }, [option]);

  return <div ref={ele} className={className} style={style} />;
};

export default Echarts;
